import React from "react";
import ReactHtmlParser from "react-html-parser";
import Layout from "../components/Layout";
import BannerManizales from "../components/BannerManizales";
import Sponsors from "../components/Sponsors";
import MenuManizales from "../components/MenuManizales";
import MenuManizalesRoutes from "../components/MenuManizalesRoutes";
import "../assets/styles/containers/SimpleSection.sass";

class SimpleSectionManizales extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      data: {},
      slug: "",
      showSubmenu: false,
    };
  }

  componentDidMount() {
    const { slug } = this.props.match.params;
    this.getData(slug);
  }

  componentWillReceiveProps(nextProps) {
    const { slug } = this.props.match.params;
    if (slug !== nextProps.match.params.slug) {
      this.getData(nextProps.match.params.slug);
    }
  }

  getData(slug) {
    fetch(`${process.env.REACT_APP_URL}/general-manizales/${slug}`)
      .then((res) => res.json())
      .then(
        (res) => {
          this.setState({ data: res });
          this.getBannerFoto(slug);
          this.handleSubmenu(slug);
        },
        (error) => {
          this.setState({ error: error });
        }
      );
    return;
  }

  getBannerFoto(slug) {
    switch (slug) {
      case "conviertete-en-patrocinador":
        this.setState({ slug: "conviertete-en-patrocinador" });
        break;
      case "informacion-de-la-expo":
        this.setState({ slug: "informacion-de-la-expo" });
        break;
      case "precios-que-incluye":
        this.setState({ slug: "precios-que-incluye" });
        break;
      default:
        this.setState({ slug: "" });
        break;
    }
  }

  handleSubmenu(slug) {
    const shouldShow =
      slug === "carrera-manizales" ||
      slug === "travesia-paramo" ||
      slug === "travesia-bosque";
    this.setState({ showSubmenu: shouldShow });
  }

  render() {
    const { data, showSubmenu } = this.state;
    const { content, sponsors } = data;
    return (
      <Layout>
        <>
          <BannerManizales
            id={15}
            city="manizales"
            thumb="/manizales/logo_manizales.png"
            picture={
              this.state.slug === "precios-que-incluye" ? "" : this.state.slug
            }
          />
          <MenuManizales />
          {showSubmenu && <MenuManizalesRoutes />}
          <div className="row content-manizales">
            {ReactHtmlParser(content?.content_es)}
          </div>
          {sponsors && <Sponsors customClass="--manizales" items={sponsors} />}
        </>
      </Layout>
    );
  }
}

export default SimpleSectionManizales;
